import React, { useState, useEffect } from "react";
import "../assetss/styles/foodItem.css";
// import { useMyContext } from '../context/MyContext';
import { useOutletContext } from "react-router-dom";
import { toUserExtent } from "@neshan-maps-platform/ol/proj";
const formatPriceWithCommas = (price) => {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const FoodItem = ({ food }) => {
  useEffect(() => {
    if (localQty == 0) {
      setIsShow(false);
    } else setIsShow(true);
  }, []);

  const [localQty, setLocalQty] = useState(0);
  const { qty, setQty } = useOutletContext();
  const { cartItems, setCartItems } = useOutletContext();
  const [isShow, setIsShow] = useState(false);
  const [isExpend, setIsExpend] = useState(false);
  const itemsPrice = cartItems.reduce((a, c) => a + c.qty * c.price, 0);

  const exist = cartItems.find((x) => x.id === food.id);
  const onAdd = (food) => {
    setQty(qty + 1);
    setLocalQty(localQty + 1);
    if (exist) {
      setCartItems(
        cartItems.map((x) =>
          x.id === food.id ? { ...exist, qty: exist.qty + 1 } : x
        )
      );
    } else {
      setCartItems([...cartItems, { ...food, qty: 1 }]);
    }
    // console.log(cartItems.length);
    setIsShow(true);
  };
  const onRemove = (product) => {
    const exist = cartItems.find((x) => x.id === product.id);
    if (exist.qty === 1) {
      setCartItems(cartItems.filter((x) => x.id !== product.id));
    } else {
      setCartItems(
        cartItems.map((x) =>
          x.id === product.id ? { ...exist, qty: exist.qty - 1 } : x
        )
      );
    }
    setQty(qty - 1);
    setLocalQty(exist.qty - 1);
  };
  const openImg = (e) => {
    setIsExpend(true)
  };
  const closeImg=()=>{
    setIsExpend(false)
  }
  return (
    <>
      { !isExpend &&
        <div className="">
        <div className="flex opacity-95  flex-col light-bg px-3 py-2 mx-2 my-2 bg-white  shadow rounded-lg dark:bg-gray-950 dark:shadwo-slate-400 ">
          <div className="top  flex justify-between pb-2 ">
            <div className="right flex justify-between items-center w-full  ">
              <div className="flex flex-col justify-between h-full">
                <h4 className="font-bold text-xl text-black dark:text-white  ">
                  {food.title}
                </h4>
                <p className=" mt-2 text-gray-600 dark:text-slate-300">
                  {food.desciption}
                </p>
              </div>
              <img
                onClick={(e) => openImg(e)}
                className="w-24 h-24 mr-4 rounded-lg brightness-90 dark:brightness-100"
                src={food.image}
                alt=""
              />
            </div>
            <div className="middle"></div>
          </div>
          <div className="bottom">{/* <p>مواد تشکیل دهنده:</p> */}</div>
          {localQty == 0 && (
            // <button onClick={onAdd} className='flex justify-center bg-red-200 p-2 mt-2'>افزودن به سبد خرید</button>
            <div className="flex justify-between items-center mt-2">
              <div className="left flex items-center flex-1 justify-center bg-white h-10 rounded-r-lg dark:bg-gray-950 ">
                <span className="flex justify-center items-center ">
                  {exist && (
                    <>
                      <span className="font-bold text-xl dark:text-white ">
                        {exist.qty}{" "}
                      </span>
                      <span className="dark:text-white flex justify-center items-center text-xs mx-1 ">
                        {" "}
                        &#10005;{" "}
                      </span>
                    </>
                  )}
                  <span className="font-bold bg-white dark:bg-gray-950   rounded-full  text-xl my-yellow ">
                    {food.price}{" "}
                    <span className="font-extralight text-base text-black dark:text-gray-400 ">
                      هزار تومان
                    </span>
                  </span>
                </span>
              </div>
              <button
                onClick={() => onAdd(food)}
                className={
                  exist
                    ? "flex flex-1 justify-center rounded-l-lg  border h-10 border-yellow-500 dark:bg-gray-700 p-2 bg-gray-100  text-gray-400"
                    : "flex flex-1 justify-center my-yellow-bg rounded-l-lg p-2 "
                }
                // className="flex justify-center bg-red-200 p-2 mt-2"
              >
                {!exist && <p>افزودن به سبد خرید</p>}
                {exist && exist.qty * food.price < 999 && (
                  <p className="flex">
                    کل:{" "}
                    <span className="dark:text-white text-black font-bold text-lg mx-1">
                      {exist.qty * food.price}
                    </span>{" "}
                    هزار تومان{" "}
                  </p>
                )}
                {exist && exist.qty * food.price >= 999 && (
                  <p>
                    کل:{" "}
                    <span className="text-red-900 font-bold text-lg">
                      {formatPriceWithCommas(exist.qty * food.price)}
                    </span>{" "}
                    میلیون تومان{" "}
                  </p>
                )}
              </button>
            </div>
          )}
          {localQty > 0 && (
            <div className="flex justify-between items-center mt-2">
              <div className="left flex items-center flex-1 justify-center">
                <span className="bg-white dark:bg-gray-900  px-6 py-1 rounded-full">
                  <p className="font-bold text-xl my-yellow  ">
                    {food.price}{" "}
                    <span className="font-extralight text-base text-black dark:text-gray-300 ">
                      هزار تومان
                    </span>
                  </p>
                </span>
              </div>
              <div className="flex flex-1 justify-between text-lg font-bold">
                <button
                  className="w-14 h-10 textblack dark:text-white bg-green-700 rounded-r-full justify-center items-center"
                  onClick={() => onAdd(food)}
                >
                  +
                </button>
                {exist ? (
                  <input
                    onChange={(e) => setQty(e.target.value)}
                    type="number"
                    value={exist.qty}
                    className="bg-white w-full text-black text-center"
                  >
                    {food.qty}
                  </input>
                ) : (
                  <input
                    onChange={(e) => setQty(e.target.value)}
                    type="number"
                    value={localQty}
                    className="bg-white text-black text-center"
                  >
                    {food.qty}
                  </input>
                )}
                <button
                  className="w-14 h-10 text-black dark:text-white bg-red-600 rounded-l-full justify-center items-center"
                  onClick={() => onRemove(food)}
                >
                  -
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      }
      {
        isExpend &&
        <div className="transition-all">
          <img
                onClick={(e)=>closeImg(e)}
                className=" w-60 mx-auto rounded-lg brightness-90 dark:brightness-100"
                src={food.image}
                alt=""
              />
              <p className="text-center text-red-600 font-bold ">برای دیدن دوباره محصول روی عکس بزنید</p>
        </div>
      }
    </>
  );
};

export default FoodItem;
